module.exports = __webpack_public_path__ + "static/media/breakdownTable4_mobile.7113296d.png";